export default __webpack_public_path__ + "static/media/main_background_courses.81c741c9.jpg";